$(document).ready(function () {
  $(".mobile-toggle").click(function () {
    // $(".mobile-toggle").toggleClass("menu-open");
    $(".nav-menu").addClass("active");
  });
  $(".menu-cross").click(function () {
    // $(".mobile-toggle").removeClass("menu-open");
    $(".nav-menu").removeClass("active");
  });
});

/*-----New hero slide----*/
$('.new-hero-slide').owlCarousel({
  loop:true,
  margin:10,
  nav:false,
  items:1,
  dots:true,
  autoplay: true,
  
})

/*-----shop list show-----*/
document.addEventListener("DOMContentLoaded", function () {

  const parents = document.querySelectorAll('.shop-nav-wrapper ul li');
  const childLists = document.querySelectorAll('.shop-hdr-sub-list');

  parents.forEach(parent => {
    parent.addEventListener('click', () => {

      // Remove active from all parents
      parents.forEach(p => p.classList.remove('active'));
      parent.classList.add('active');

      // Hide all child lists
      childLists.forEach(list => list.classList.remove('active'));

      // Show selected child list
      const target = parent.getAttribute('data-target');
      const targetEl = document.getElementById(target);

      if (targetEl) {
        targetEl.classList.add('active');
      }

    });
  });

});

// $(document).ready(function () {
//   $(window).scroll(function () {
//     if ($(this).scrollTop() > 10) {
//       $("#header-section").addClass("sticky");
//     } else {
//       $("#header-section").removeClass("sticky");
//     }
//   });
// });

//Banner slider
// var swiper = new Swiper(".banner-slide", {
//     direction: "vertical",
//     slidesPerView: 1,
//     autoHeight: false,
//     autoplay: true,
//     pagination: {
//       el: ".swiper-pagination",
//       clickable: true,
//     },
//     mousewheel: false,
//   });
var swiper = new Swiper(".banner-slide", {
  direction: "vertical",
  slidesPerView: 1,
  autoHeight: false,
  
  autoplay: {
    delay: 5000, // 5 seconds delay before first slide change
    disableOnInteraction: false
  },

  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  mousewheel: false,
});
//Featured product
$('.featured-product-slide').owlCarousel({
  loop: false,
  margin: 20,
  items: 4,
  dots: false,
  autoplay: false,
  nav: true,
  navText: [
    '<span class="custom-prev"><img src="https://cdn.shopify.com/s/files/1/0682/2235/3475/files/arrow-left.svg?v=1775256551"></span>',
    '<span class="custom-next"><img src="https://cdn.shopify.com/s/files/1/0682/2235/3475/files/arrow-right.svg?v=1775256552"></span>'
  ],
  responsive: {
    0: {
      items: 2
    },
    576: {
      items: 3
    },
    1000: {
      items: 3
    },
    1200: {
      items: 4
    }
  }
});

//Featured product
$('.tsti-slide').owlCarousel({
  loop: false,
  margin: 16,
  items: 3,
  dots: false,
  autoplay: false,
  nav: true,
  navText: [
    '<span class="custom-prev"><img src="https://cdn.shopify.com/s/files/1/0682/2235/3475/files/arrow-left.svg?v=1775256551"></span>',
    '<span class="custom-next"><img src="https://cdn.shopify.com/s/files/1/0682/2235/3475/files/arrow-right.svg?v=1775256552"></span>'
  ],
  responsive: {
    0: {
      items: 1,
      nav: true
    },
    576: {
      items: 3
    },
    1000: {
      items: 3
    },
    1200: {
      items: 3
    }
  }
});


    if ($(window).width() < 575) {
        $('.bcs-blog-slider-mobile').owlCarousel({
            loop: true,
            margin: 15,
            nav: true,
            navText: [
              '<span class="custom-prev"><img src="https://cdn.shopify.com/s/files/1/0682/2235/3475/files/arrow-left.svg?v=1775256551"></span>',
              '<span class="custom-next"><img src="https://cdn.shopify.com/s/files/1/0682/2235/3475/files/arrow-right.svg?v=1775256552"></span>'
            ],
            dots: false,
            autoplay: false,
            smartSpeed: 500,
            responsive: {
                0: {
                    items: 1
                },
                576: {
                    items: 1    
                }
            }
        });
    }





// $(document).ready(function () {

//   var originalSliderHTML = $('.quick-view-slide').html();

//   $('#quick-view').on('shown.bs.modal', function () {
//     var $slider = $('.quick-view-slide');

//     if ($slider.hasClass('owl-loaded')) {
//       $slider.trigger('destroy.owl.carousel');
//     }

//     $slider.empty().html(originalSliderHTML);

//     setTimeout(function () {
//       $slider.owlCarousel({
//         loop: false,
//         margin: 0,
//         items: 1,
//         dots: false,
//         autoplay: false,
//         nav: true,
//         startPosition: 0,
//         autoWidth: false,
//       });

//       $slider.trigger('refresh.owl.carousel');
//     }, 300);
//   });

//   $('#quick-view').on('hide.bs.modal', function () {
//     var $slider = $('.quick-view-slide');
//     if ($slider.hasClass('owl-loaded')) {
//       $slider.trigger('destroy.owl.carousel');
//     }
//     $slider.empty().html(originalSliderHTML);
//   });

// });



//Product details
$(document).ready(function () {

  /* =========================
     INIT MAIN SLIDER
  ========================== */

  var $main = $('.main-slider').owlCarousel({
    items: 1,
    loop: true,
    nav: true,
    navText: ['<i class="fa-solid fa-chevron-left fs-2"></i>', '<i class="fa-solid fa-chevron-right fs-2"></i>'],
    dots: false,
    smartSpeed: 400,
  });

  /* =========================
     THUMB CLICK → GO TO SLIDE
  ========================== */

  $('#thumbCol').on('click', '.thumb-item', function () {

    var idx = parseInt($(this).data('index'));

    $main.trigger('to.owl.carousel', [idx, 300]);

    setActive(idx);
  });

  /* =========================
     MAIN SLIDE CHANGE → UPDATE THUMB
  ========================== */

  $main.on('changed.owl.carousel', function (e) {

    var pos = e.relatedTarget.relative(e.item.index);

    setActive(pos);

    // Auto scroll active thumbnail into view
    var activeThumb = $('#thumbCol .thumb-item[data-index="' + pos + '"]')[0];

    if (activeThumb) {
      activeThumb.scrollIntoView({
        behavior: "smooth",
        block: "nearest"
      });
    }

    // Recalculate height after slide change
    setTimeout(function () {
      matchThumbHeight();
    }, 100);

  });

  function setActive(idx) {
    $('#thumbCol .thumb-item').removeClass('active');
    $('#thumbCol .thumb-item[data-index="' + idx + '"]').addClass('active');
  }

  /* =========================
     MATCH THUMB HEIGHT TO MAIN IMAGE
  ========================== */

  function matchThumbHeight() {
    var mainImg = $('.main-slider .owl-item.active img');

    if (mainImg.length) {
      var h = mainImg.outerHeight();
      $('#thumbCol').height(h);
    }
  }

  // Run after page fully loads
  $(window).on('load', function () {
    matchThumbHeight();
  });

  // Run on resize
  $(window).on('resize', function () {
    matchThumbHeight();
  });

  /* =========================
     DRAG SCROLL FOR THUMB COLUMN
  ========================== */

  // var slider = document.getElementById('thumbCol');

  // let isDown = false;
  // let startY;
  // let scrollTop;

  // slider.addEventListener('mousedown', function (e) {
  //   isDown = true;
  //   slider.style.cursor = "grabbing";
  //   startY = e.pageY - slider.offsetTop;
  //   scrollTop = slider.scrollTop;
  // });

  // slider.addEventListener('mouseleave', function () {
  //   isDown = false;
  //   slider.style.cursor = "grab";
  // });

  // slider.addEventListener('mouseup', function () {
  //   isDown = false;
  //   slider.style.cursor = "grab";
  // });

  // slider.addEventListener('mousemove', function (e) {
  //   if (!isDown) return;
  //   e.preventDefault();
  //   const y = e.pageY - slider.offsetTop;
  //   const walk = (y - startY) * 1.5;
  //   slider.scrollTop = scrollTop - walk;
  // });
  var slider = document.getElementById('thumbCol');

    if (slider) {
      let isDown = false;
      let startY;
      let scrollTop;

      slider.addEventListener('mousedown', function (e) {
        isDown = true;
        slider.style.cursor = "grabbing";
        startY = e.pageY - slider.offsetTop;
        scrollTop = slider.scrollTop;
      });

      slider.addEventListener('mouseleave', function () {
        isDown = false;
        slider.style.cursor = "grab";
      });

      slider.addEventListener('mouseup', function () {
        isDown = false;
        slider.style.cursor = "grab";
      });

      slider.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();

        const y = e.pageY - slider.offsetTop;
        const walk = (y - startY) * 1.5;

        slider.scrollTop = scrollTop - walk;
      });
    }

});




//Quantity 
// (function () {
//   const quantityContainer = document.querySelector(".quantity");
//   const minusBtn = quantityContainer.querySelector(".minus");
//   const plusBtn = quantityContainer.querySelector(".plus");
//   const inputBox = quantityContainer.querySelector(".input-box");

//   updateButtonStates();

//   quantityContainer.addEventListener("click", handleButtonClick);
//   inputBox.addEventListener("input", handleQuantityChange);

//   function updateButtonStates() {
//     const value = parseInt(inputBox.value);
//     minusBtn.disabled = value <= 1;
//     plusBtn.disabled = value >= parseInt(inputBox.max);
//   }

//   function handleButtonClick(event) {
//     if (event.target.classList.contains("minus")) {
//       decreaseValue();
//     } else if (event.target.classList.contains("plus")) {
//       increaseValue();
//     }
//   }

//   function decreaseValue() {
//     let value = parseInt(inputBox.value);
//     value = isNaN(value) ? 1 : Math.max(value - 1, 1);
//     inputBox.value = value;
//     updateButtonStates();
//     handleQuantityChange();
//   }

//   function increaseValue() {
//     let value = parseInt(inputBox.value);
//     value = isNaN(value) ? 1 : Math.min(value + 1, parseInt(inputBox.max));
//     inputBox.value = value;
//     updateButtonStates();
//     handleQuantityChange();
//   }

//   function handleQuantityChange() {
//     let value = parseInt(inputBox.value);
//     value = isNaN(value) ? 1 : value;

//     // Execute your code here based on the updated quantity value
//     console.log("Quantity changed:", value);
//   }
// })();






//Featured product
$('.related-comics-slide').owlCarousel({
  loop: false,
  margin: 20,
  items: 4,
  dots: false,
  autoplay: false,
  nav: true,
  navText: [
    '<span class="custom-prev"><img src="https://cdn.shopify.com/s/files/1/0682/2235/3475/files/arrow-left.svg?v=1775256551"></span>',
    '<span class="custom-next"><img src="https://cdn.shopify.com/s/files/1/0682/2235/3475/files/arrow-right.svg?v=1775256552"></span>'
  ],
  responsive: {
    0: {
      items: 2,
      nav: false
    },
    576: {
      items: 3
    },
    1000: {
      items: 3
    },
    1200: {
      items: 4
    }
  }
});



(function() {
  const btn = document.getElementById('accountBtn');
  const dropdown = document.getElementById('accountDropdown');

  if (!btn || !dropdown) return;

  btn.addEventListener('mouseenter', function() {
    dropdown.classList.add('open');
    btn.setAttribute('aria-expanded', 'true');
  });

  btn.addEventListener('mouseleave', function() {
    dropdown.classList.remove('open');
    btn.setAttribute('aria-expanded', 'false');
  });

  dropdown.addEventListener('mouseenter', function() {
    dropdown.classList.add('open');
  });

  dropdown.addEventListener('mouseleave', function() {
    dropdown.classList.remove('open');
    btn.setAttribute('aria-expanded', 'false');
  });
})();




document.addEventListener('DOMContentLoaded', function () {
  async function injectSizes() {
    let items = document.querySelectorAll('dd[data-id]');

    items.forEach(async (item) => {
      let link = item.querySelector('a.cs-product-link');
      let price = item.querySelector('.price');

      if (!link || !price) return;

      // prevent duplicate
      if (item.querySelector('.variant-sizes')) return;

      let href = link.getAttribute('href'); // /products/handle
      if (!href || !href.includes('/products/')) return;

      let handle = href.split('/products/')[1];

      try {
        let res = await fetch(`/products/${handle}.js`);
        let product = await res.json();

        let sizes = product.variants.map((v) => v.option1);
        sizes = [...new Set(sizes)];

        if (sizes.length) {
          let div = document.createElement('div');
          div.className = 'variant-sizes';
          div.innerHTML = sizes.join(' / ');
          div.style.fontSize = '12px';
          div.style.marginBottom = '4px';

          price.parentNode.insertBefore(div, price);
        }
      } catch (e) {
        console.log('Variant fetch error:', e);
      }
    });
  }

  // 🔁 Run multiple times because XCloud loads async
  setInterval(injectSizes, 1000);
});



$(function () {
    $('#travelBanner').owlCarousel({
      loop: true,
      margin: 0,
      nav: true,
      dots: true,
      autoplay: true,
      autoplayTimeout: 4000,
      autoplayHoverPause: true,

      navText: ['<i class="fa-solid fa-chevron-left"></i>', '<i class="fa-solid fa-chevron-right"></i>'],
      responsive: {
        0: { items: 1 },
        768: { items: 1 },
        1200: { items: 1 },
      },
    });
  });



document.querySelectorAll(".shop-nav-wrapper, .child-wrapper").forEach(wrapper => {
    const nav = wrapper.querySelector("ul");
    const prev = wrapper.querySelector(".shop-nav-prev");
    const next = wrapper.querySelector(".shop-nav-next");

    if (!nav || !prev || !next) return;

    function scrollNav(amount) {
        const target = Math.max(
            0,
            Math.min(
                nav.scrollLeft + amount,
                nav.scrollWidth - nav.clientWidth
            )
        );

        nav.scrollTo({
            left: target,
            behavior: "smooth"
        });
    }

    prev.addEventListener("click", () => scrollNav(-180));
    next.addEventListener("click", () => scrollNav(180));
});


document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth > 768) return;

  const desc = document.getElementById("productDescription");
  const btn = document.getElementById("descriptionToggle");

  if (!desc || !btn) return;

  // Hide button if description is short
  if (desc.scrollHeight <= desc.clientHeight + 5) {
    btn.classList.add("hide");
    return;
  }

  btn.addEventListener("click", function () {
    desc.classList.toggle("expanded");

    if (desc.classList.contains("expanded")) {
      btn.textContent = "Show Less";
    } else {
      btn.textContent = "Show More";
    }
  });
});





window.addEventListener('load', function () {
  requestAnimationFrame(function () {
    document.querySelectorAll('[data-predictive-search]').forEach(function (search) {
      search.style.display = '';
    });
  });
});